import { render, staticRenderFns } from "./pieds.vue?vue&type=template&id=71606d67&"
import script from "./pieds.vue?vue&type=script&lang=js&"
export * from "./pieds.vue?vue&type=script&lang=js&"
import style0 from "./pieds.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports